import React from 'react';
import { has } from 'lodash';
import { usePrepopulationContext } from 'domain/people/employee/prepopulation/PrepopulationContext';
import { Box } from '@mui/material';

export const CLASS_NAME = 'input-prepopulated';

const PrepopulationWrapper = ({ children = null }: { children?: React.ReactNode }) => {
  const { data } = usePrepopulationContext();

  const className = (source: any) => {
    const prepopulatedValue = has(data, source);

    if (prepopulatedValue) {
      return CLASS_NAME;
    }

    return '';
  };

  return (
    <Box
      sx={theme => ({
        display: 'contents',
        '& .input-prepopulated .form-control': {
          borderColor: 'primary.main',
          boxShadow: `0 0 0 0.2rem ${theme.palette.common.softShadow}`,
        },
      })}
    >
      {
        // @ts-ignore
        React.cloneElement(children, {
          className,
        })
      }
    </Box>
  );
};

export default PrepopulationWrapper;
